const conversationTypes = {
  FETCH_CONVERSATIONS_START: 'FETCH_CONVERSATIONS_START',
  FETCH_CHATS_START: 'FETCH_CHATS_START',

  SET_CONVERSATIONS_COUNT: 'SET_CONVERSATIONS_COUNT',
  SET_AGENT_STARTED_CONVERSATIONS_COUNT: 'SET_AGENT_STARTED_CONVERSATIONS_COUNT',
  SET_CONVERSATIONS: 'SET_CONVERSATIONS',
  SET_CHATS : "SET_CHATS",

  LOADING_CONVERSATIONS: 'LOADING_CONVERSATIONS',
  LOADING_CHATS: 'LOADING_CHATS',
};

export default conversationTypes;
